import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Global } from '../../shared/global';
import { EMPTY, Observable, from } from 'rxjs';
import { IKfzOffert } from '../models/kfzoffert';
import { IRsOffert } from '../models/rsoffert';
import { map, switchMap } from 'rxjs/operators';
import { IKfzOffertResult } from '../models/kfzoffertresult';
import { IOffertVerificationResult } from '../models/offertverificationresult';
import { IOffertVerification } from '../models/offertverification';
import { IPasscodeResetResult } from '../models/passwordresetresult';
import { IHvOffert } from '../models/hvoffert';
import { MaintainanceService } from './maintainance.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OffertService {

  constructor(private http: HttpClient, private router: Router, private maintainanceService: MaintainanceService) { }

  createKfzOffert(model: IKfzOffert, query: string, solution: Promise<string>): Observable<IKfzOffertResult> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post<IKfzOffertResult>(Global.BASE_OFFERT_ENDPOINT +
              `createkfzoffert?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options)));
        }
      }));
  }

  createRsOffert(model: IRsOffert, query: string, solution: Promise<string>): Observable<any> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, responseType: 'blob' as 'blob' };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post(Global.BASE_OFFERT_ENDPOINT +
              `creatersoffert?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options).pipe(map(data => {
                return new Blob([data], { type: 'application/pdf', });
              }))));
        }
      }));
  }

  createHvOffert(model: IHvOffert, query: string, solution: Promise<string>): Observable<any> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, responseType: 'blob' as 'blob' };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return from(solution).pipe(
            switchMap(solution => this.http.post(Global.BASE_OFFERT_ENDPOINT +
              `createhvoffert?captchaResponse=${encodeURIComponent(solution)}` + (query ? `&q=${query}` : ''), body, options).pipe(map(data => {
                return new Blob([data], { type: 'application/pdf', });
              }))));
        }
      }));
  }


  verifyOffertLink(query: string): Observable<IOffertVerificationResult> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IOffertVerificationResult>(Global.BASE_OFFERT_ENDPOINT +
            `verifyoffertlink` + (query ? `?q=${query}` : ''), null, options);
        }
      }));
  }


  getOffertById(model: IOffertVerification, query: string): Observable<IOffertVerificationResult> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IOffertVerificationResult>(Global.BASE_OFFERT_ENDPOINT +
            `getoffertbyid` + (query ? `?q=${query}` : ''), body, options);
        }
      }));
  }


  sendPasscodeResetLink(query: string): Observable<HttpResponse<Response>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers, observe: 'response' as 'body' };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<HttpResponse<Response>>(Global.BASE_OFFERT_ENDPOINT +
            `sendpasscoderesetlink` + (query ? `?q=${query}` : ''), null, options);
        }
      }));
  }


  sendPasscodeGeneratedNotification(query: string): Observable<IPasscodeResetResult> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IPasscodeResetResult>(Global.BASE_OFFERT_ENDPOINT +
            `sendpasscodegeneratednotification` + (query ? `?q=${query}` : ''), null, options);
        }
      }));
  }
}
